import angular from 'angular';
import './openRateMap.scss';

export default angular.module('cms.mails.openRateMap', [])
    .component('mailOpenRateMap', {
        template: require('./openRateMap.html'),
        controller: (baConfig, layoutPaths, baUtil, $http, $scope, languageManager, CONFIG, gettextCatalog) => {

            let layoutColors = baConfig.colors;
            let map;

            let createMap = (areas) => {
                map = AmCharts.makeChart('openRateMap', {
                    type: "map",
                    theme: "light",
                    zoomControl: {
                        zoomControlEnabled: false,
                        panControlEnabled: false
                    },
                    dataProvider: {
                        map: 'worldLow',
                        zoomLevel: 3.5,
                        zoomLongitude: 10,
                        zoomLatitude: 52,
                        areas: areas
                    },
                    areasSettings: {
                        rollOverOutlineColor: layoutColors.border,
                        rollOverColor: layoutColors.dashboard.blueStone,
                        alpha: 0.8,
                        unlistedAreasAlpha: 0.2,
                        unlistedAreasColor: layoutColors.defaultText,
                        balloonText: gettextCatalog.getString('[[title]]: [[customData]] mails opened')
                    },
            })};



            $http.get(CONFIG.API_URL+'/mailsStats/openRate').then(
                (response) => {
                    let areas = response.data;

                    angular.forEach(areas, (area) => {
                        area.groupId = area.customData < 250 ? 4 :
                                       area.customData < 500 ? 3 :
                                       area.customData < 750 ? 2 : 1;
                        area.color = area.groupId === 1 ? layoutColors.primary :
                                     area.groupId === 2 ? layoutColors.success :
                                     area.groupId === 3 ? layoutColors.warning : layoutColors.danger;
                    });

                    createMap(areas);
                }
            );
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Mails/OpenRateMap/OpenRateMap.js